import { isAbortError } from '@prenuvo/pulse';
import { QueryClient } from '@tanstack/react-query';

import { HttpError } from '@/api';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,

      retry: (failureCount, error) => {
        if (isAbortError(error)) {
          return false;
        }

        if (error instanceof HttpError && [401, 403, 404].includes(error.status)) {
          return false;
        }

        return failureCount < 2;
      },
      staleTime: 5 * 60 * 1000, // 5 minutes
    },
  },
});
